import { render, staticRenderFns } from "./index.2.vue?vue&type=template&id=014c7386&scoped=true&"
import script from "./index.2.vue?vue&type=script&lang=js&"
export * from "./index.2.vue?vue&type=script&lang=js&"
import style0 from "./index.2.vue?vue&type=style&index=0&id=014c7386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c7386",
  null
  
)

export default component.exports